module.exports = __webpack_public_path__ + "static/media/message.e668b4a0.svg";